import React, { useState, useEffect } from "react";
import { 
    Card, Row, Col, Form, Button, Alert, Spinner, InputGroup
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Footer from "../layouts/Footer";
import Header from "../layouts/Header";
import { API_BASE_URL } from "../constants/api";


export default function AjouterProduit() {
    const navigate = useNavigate();
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    
    const [produit, setProduit] = useState({
        reference: '',
        code_barre: '',
        designation: '',
        description: '',
        id_categorie: '',
        unite_mesure: 'PCE',
        prix_achat_ht: 0,
        prix_vente_ht: 0,
        tva_taux: 18,
        css_taux: 1,
        seuil_alerte: 5,
        stock_minimum: 0,
        stock_maximum: '',
        emplacement: '',
        actif: 1
    });

    useEffect(() => {
        fetchCategories();
    }, []);

    const fetchCategories = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(
                `${API_BASE_URL}/categories.php`,
                { headers: { 'Authorization': `Bearer ${token}` } }
            );
            
            if (response.ok) {
                const result = await response.json();
                setCategories(result.data || []);
            }
        } catch (err) {
            console.error("Erreur chargement catégories", err);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!produit.designation) {
            setError("La désignation est obligatoire");
            return;
        }
        
        if (!produit.prix_achat_ht || produit.prix_achat_ht <= 0) {
            setError("Le prix d'achat doit être supérieur à 0");
            return;
        }
        
        if (!produit.prix_vente_ht || produit.prix_vente_ht <= 0) {
            setError("Le prix de vente doit être supérieur à 0");
            return;
        }

        setSaving(true);
        setError("");

        try {
            const token = localStorage.getItem("token");
            const response = await fetch(
                `${API_BASE_URL}/produits.php`,
                {
                    method: 'POST',
                    headers: { 
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(produit)
                }
            );

            const result = await response.json();

            if (result.success) {
                setSuccess("Produit créé avec succès !");
                setTimeout(() => {
                    navigate('/stock/produits');
                }, 2000);
            } else {
                setError(result.message || "Erreur lors de la création");
            }
        } catch (err) {
            setError("Erreur de connexion au serveur");
        } finally {
            setSaving(false);
        }
    };

    // Options d'unité de mesure avec icônes
    const uniteOptions = [
        { value: 'PCE', label: '📦 Pièce', icon: 'ri-cube-line' },
        { value: 'KG', label: '⚖️ Kilogramme', icon: 'ri-scales-line' },
        { value: 'L', label: '💧 Litre', icon: 'ri-drop-line' },
        { value: 'M', label: '📏 Mètre', icon: 'ri-ruler-line' },
        { value: 'CART', label: '📦 Carton', icon: 'ri-box-3-line' },
        { value: 'PAL', label: '📦 Palette', icon: 'ri-stack-line' }
    ];

    return (
        <>
            <Header />
            <div className="main main-app p-3 p-lg-4" style={{ background: '#f8fafc', minHeight: '100vh' }}>
                <div className="container-fluid">
                    {/* En-tête simplifié */}
                    <div className="d-md-flex align-items-center justify-content-between mb-4">
                        <div>
                            <div className="d-flex align-items-center gap-2 mb-2">
                                <div className="p-2 bg-primary bg-opacity-10 rounded-3">
                                    <i className="ri-add-line fs-20 text-primary" style={{ color: '#21ACCD' }}></i>
                                </div>
                                <div>
                                    <h4 className="main-title mb-0 fw-bold">Ajouter un produit</h4>
                                    <p className="text-muted small mb-0">Créez un nouveau produit dans le catalogue</p>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex gap-2 mt-3 mt-md-0">
                            <Button 
                                variant="outline-secondary" 
                                onClick={() => navigate('/stock/produits')}
                                className="rounded-pill px-3 d-flex align-items-center gap-1"
                                size="sm"
                            >
                                <i className="ri-arrow-left-line"></i>
                                Retour
                            </Button>
                        </div>
                    </div>

                    {/* Alertes modernes */}
                    {error && (
                        <Alert variant="danger" onClose={() => setError("")} dismissible className="mb-4 alert-modern">
                            <i className="ri-error-warning-line me-2 fs-5"></i>
                            {error}
                        </Alert>
                    )}
                    
                    {success && (
                        <Alert variant="success" onClose={() => setSuccess("")} dismissible className="mb-4 alert-modern">
                            <i className="ri-checkbox-circle-line me-2 fs-5"></i>
                            {success}
                        </Alert>
                    )}

                    <Row className="justify-content-center">
                        <Col lg={10}>
                            <Card className="border-0 shadow-sm rounded-3">
                                <Card.Header className="py-3" style={{ background: '#21ACCD', borderTopLeftRadius: '12px', borderTopRightRadius: '12px' }}>
                                    <h5 className="mb-0 text-white">
                                        <i className="ri-information-line me-2"></i>
                                        Informations du produit
                                    </h5>
                                </Card.Header>
                                <Card.Body className="p-4">
                                    <Form onSubmit={handleSubmit}>
                                        <Row className="g-4">
                                            {/* SECTION 1 : Informations de base */}
                                            <Col md={12}>
                                                <h6 className="mb-3 fw-semibold" style={{ color: '#21ACCD' }}>
                                                    <i className="ri-information-line me-2"></i>
                                                    Informations de base
                                                </h6>
                                            </Col>
                                            
                                            <Col md={6}>
                                                <Form.Group>
                                                    <Form.Label className="fw-semibold">Référence</Form.Label>
                                                    <InputGroup>
                                                        <InputGroup.Text className="bg-light border-2">
                                                            <i className="ri-barcode-line"></i>
                                                        </InputGroup.Text>
                                                        <Form.Control
                                                            type="text"
                                                            value={produit.reference}
                                                            onChange={(e) => setProduit({...produit, reference: e.target.value})}
                                                            placeholder="Générée automatiquement si vide"
                                                            className="border-2"
                                                        />
                                                    </InputGroup>
                                                    <Form.Text className="text-muted small">
                                                        Laissez vide pour génération automatique
                                                    </Form.Text>
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group>
                                                    <Form.Label className="fw-semibold">Code-barres</Form.Label>
                                                    <InputGroup>
                                                        <InputGroup.Text className="bg-light border-2">
                                                            <i className="ri-qr-code-line"></i>
                                                        </InputGroup.Text>
                                                        <Form.Control
                                                            type="text"
                                                            value={produit.code_barre}
                                                            onChange={(e) => setProduit({...produit, code_barre: e.target.value})}
                                                            placeholder="Optionnel"
                                                            className="border-2"
                                                        />
                                                    </InputGroup>
                                                </Form.Group>
                                            </Col>
                                            <Col md={12}>
                                                <Form.Group>
                                                    <Form.Label className="fw-semibold">Désignation <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={produit.designation}
                                                        onChange={(e) => setProduit({...produit, designation: e.target.value})}
                                                        required
                                                        className="border-2 rounded-3"
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={12}>
                                                <Form.Group>
                                                    <Form.Label className="fw-semibold">Description</Form.Label>
                                                    <Form.Control
                                                        as="textarea"
                                                        rows={3}
                                                        value={produit.description}
                                                        onChange={(e) => setProduit({...produit, description: e.target.value})}
                                                        placeholder="Description du produit..."
                                                        className="border-2 rounded-3"
                                                    />
                                                </Form.Group>
                                            </Col>
                                            
                                            <Col md={6}>
                                                <Form.Group>
                                                    <Form.Label className="fw-semibold">Catégorie</Form.Label>
                                                    <Form.Select
                                                        value={produit.id_categorie}
                                                        onChange={(e) => setProduit({...produit, id_categorie: e.target.value})}
                                                        className="border-2 rounded-3"
                                                    >
                                                        <option value="">Sélectionner une catégorie</option>
                                                        {categories.map(cat => (
                                                            <option key={cat.id_categorie} value={cat.id_categorie}>
                                                                {cat.nom_categorie}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group>
                                                    <Form.Label className="fw-semibold">Unité de mesure</Form.Label>
                                                    <Form.Select
                                                        value={produit.unite_mesure}
                                                        onChange={(e) => setProduit({...produit, unite_mesure: e.target.value})}
                                                        className="border-2 rounded-3"
                                                    >
                                                        {uniteOptions.map(opt => (
                                                            <option key={opt.value} value={opt.value}>
                                                                {opt.label}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>

                                            {/* SECTION 2 : Prix et taxes */}
                                            <Col md={12}>
                                                <h6 className="mb-3 mt-2 fw-semibold" style={{ color: '#21ACCD' }}>
                                                    <i className="ri-money-euro-circle-line me-2"></i>
                                                    Prix et taxes
                                                </h6>
                                            </Col>
                                            
                                            <Col md={6}>
                                                <Form.Group>
                                                    <Form.Label className="fw-semibold">Prix d'achat HT <span className="text-danger">*</span></Form.Label>
                                                    <InputGroup>
                                                        <Form.Control
                                                            type="number"
                                                            step="0.01"
                                                            min="0"
                                                            value={produit.prix_achat_ht}
                                                            onChange={(e) => setProduit({...produit, prix_achat_ht: parseFloat(e.target.value) || 0})}
                                                            required
                                                            className="border-2"
                                                        />
                                                        <InputGroup.Text className="border-2">FCFA</InputGroup.Text>
                                                    </InputGroup>
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group>
                                                    <Form.Label className="fw-semibold">Prix de vente HT <span className="text-danger">*</span></Form.Label>
                                                    <InputGroup>
                                                        <Form.Control
                                                            type="number"
                                                            step="0.01"
                                                            min="0"
                                                            value={produit.prix_vente_ht}
                                                            onChange={(e) => setProduit({...produit, prix_vente_ht: parseFloat(e.target.value) || 0})}
                                                            required
                                                            className="border-2"
                                                        />
                                                        <InputGroup.Text className="border-2">FCFA</InputGroup.Text>
                                                    </InputGroup>
                                                </Form.Group>
                                            </Col>
                                            <Col md={4}>
                                                <Form.Group>
                                                    <Form.Label className="fw-semibold">TVA (%)</Form.Label>
                                                    <InputGroup>
                                                        <Form.Control
                                                            type="number"
                                                            step="0.1"
                                                            min="0"
                                                            max="100"
                                                            value={produit.tva_taux}
                                                            onChange={(e) => setProduit({...produit, tva_taux: parseFloat(e.target.value) || 0})}
                                                            className="border-2"
                                                        />
                                                        <InputGroup.Text className="border-2">%</InputGroup.Text>
                                                    </InputGroup>
                                                </Form.Group>
                                            </Col>
                                            <Col md={4}>
                                                <Form.Group>
                                                    <Form.Label className="fw-semibold">CSS (%)</Form.Label>
                                                    <InputGroup>
                                                        <Form.Control
                                                            type="number"
                                                            step="0.1"
                                                            min="0"
                                                            max="100"
                                                            value={produit.css_taux}
                                                            onChange={(e) => setProduit({...produit, css_taux: parseFloat(e.target.value) || 0})}
                                                            className="border-2"
                                                        />
                                                        <InputGroup.Text className="border-2">%</InputGroup.Text>
                                                    </InputGroup>
                                                </Form.Group>
                                            </Col>
                                            <Col md={4}>
                                                <Form.Group>
                                                    <Form.Label className="fw-semibold">Marge (est.)</Form.Label>
                                                    <div className="bg-light p-2 rounded-3 text-center">
                                                        {produit.prix_achat_ht > 0 ? (
                                                            <span className="fw-bold text-success">
                                                                {((produit.prix_vente_ht - produit.prix_achat_ht) / produit.prix_achat_ht * 100).toFixed(1)}%
                                                            </span>
                                                        ) : (
                                                            <span className="text-muted">-</span>
                                                        )}
                                                    </div>
                                                </Form.Group>
                                            </Col>

                                            {/* SECTION 3 : Gestion de stock */}
                                            <Col md={12}>
                                                <h6 className="mb-3 mt-2 fw-semibold" style={{ color: '#21ACCD' }}>
                                                    <i className="ri-stack-line me-2"></i>
                                                    Gestion de stock
                                                </h6>
                                            </Col>
                                            
                                            <Col md={4}>
                                                <Form.Group>
                                                    <Form.Label className="fw-semibold">Seuil d'alerte</Form.Label>
                                                    <InputGroup>
                                                        <Form.Control
                                                            type="number"
                                                            min="0"
                                                            value={produit.seuil_alerte}
                                                            onChange={(e) => setProduit({...produit, seuil_alerte: parseInt(e.target.value) || 0})}
                                                            className="border-2"
                                                        />
                                                        <InputGroup.Text className="border-2">unités</InputGroup.Text>
                                                    </InputGroup>
                                                </Form.Group>
                                            </Col>
                                            <Col md={4}>
                                                <Form.Group>
                                                    <Form.Label className="fw-semibold">Stock minimum</Form.Label>
                                                    <InputGroup>
                                                        <Form.Control
                                                            type="number"
                                                            min="0"
                                                            value={produit.stock_minimum}
                                                            onChange={(e) => setProduit({...produit, stock_minimum: parseInt(e.target.value) || 0})}
                                                            className="border-2"
                                                        />
                                                        <InputGroup.Text className="border-2">unités</InputGroup.Text>
                                                    </InputGroup>
                                                </Form.Group>
                                            </Col>
                                            <Col md={4}>
                                                <Form.Group>
                                                    <Form.Label className="fw-semibold">Stock maximum</Form.Label>
                                                    <InputGroup>
                                                        <Form.Control
                                                            type="number"
                                                            min="0"
                                                            value={produit.stock_maximum}
                                                            onChange={(e) => setProduit({...produit, stock_maximum: parseInt(e.target.value) || ''})}
                                                            className="border-2"
                                                        />
                                                        <InputGroup.Text className="border-2">unités</InputGroup.Text>
                                                    </InputGroup>
                                                </Form.Group>
                                            </Col>
                                            <Col md={12}>
                                                <Form.Group>
                                                    <Form.Label className="fw-semibold">Emplacement</Form.Label>
                                                    <InputGroup>
                                                        <InputGroup.Text className="bg-light border-2">
                                                            <i className="ri-map-pin-line"></i>
                                                        </InputGroup.Text>
                                                        <Form.Control
                                                            type="text"
                                                            value={produit.emplacement}
                                                            onChange={(e) => setProduit({...produit, emplacement: e.target.value})}
                                                            placeholder="Ex: A-12-3"
                                                            className="border-2"
                                                        />
                                                    </InputGroup>
                                                </Form.Group>
                                            </Col>
                                            
                                            {/* SECTION 4 : Actions */}
                                            <Col md={12}>
                                                <hr className="my-3" />
                                                <div className="d-flex justify-content-end gap-3">
                                                    <Button 
                                                        variant="outline-secondary" 
                                                        onClick={() => navigate('/stock/produits')}
                                                        className="rounded-pill px-4"
                                                    >
                                                        Annuler
                                                    </Button>
                                                    <Button 
                                                        type="submit" 
                                                        variant="primary"
                                                        disabled={saving}
                                                        className="rounded-pill px-5"
                                                        style={{ background: '#21ACCD', border: 'none' }}
                                                    >
                                                        {saving ? (
                                                            <>
                                                                <Spinner size="sm" className="me-2" />
                                                                Création...
                                                            </>
                                                        ) : (
                                                            <>
                                                                <i className="ri-save-line me-2"></i>
                                                                Créer le produit
                                                            </>
                                                        )}
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </div>
                <Footer />
            </div>

            <style>{`
                .border-2 {
                    border-width: 2px !important;
                    border-color: #e2e8f0;
                }
                .border-2:focus {
                    border-color: #21ACCD;
                    box-shadow: 0 0 0 3px rgba(33, 172, 205, 0.1);
                }
                
                .rounded-3 {
                    border-radius: 12px !important;
                }
                
                .rounded-pill {
                    border-radius: 50px !important;
                }
                
                .alert-modern {
                    border: none;
                    border-radius: 12px;
                    padding: 1rem 1.5rem;
                    box-shadow: 0 4px 8px rgba(0,0,0,0.05);
                }
                
                .fs-20 {
                    font-size: 1.25rem;
                }
            `}</style>
        </>
    );
}